export default "__VITE_ASSET__hmNyFsPsiVclnnNiRdHSzw__"